import { Link } from 'react-router-dom';
import { Monitor, ArrowRight, Settings as SettingsIcon } from 'lucide-react';
import Brand from '../Brand';

// Mobile gate for the calculator route. Per the mobile-policy memo,
// the new calculator UI is desktop-only; rather than ship a degraded
// mobile experience we surface a clear "open on desktop" splash. Auth
// pages, legal, FAQ, 404 and the marketing landing stay responsive,
// so a user can still manage their account or read docs on a phone.
//
// Threshold (768 px) + the resize-tracking hook live in
// src/hooks/useTooNarrowForCalculator.js — kept separate so this
// file only exports components (react-refresh requirement).

export default function MobileSplash() {
  return (
    <div className="min-h-screen bg-page flex items-center justify-center px-6 py-12 relative overflow-hidden">
      {/* Soft background spots — same vocabulary as the auth pages so
          the splash feels native to the app shell, not a stranded
          error screen. */}
      <div aria-hidden="true" className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/3 left-1/4 w-80 h-80 bg-brand/15 rounded-full blur-3xl" />
        <div className="absolute bottom-1/3 right-1/4 w-80 h-80 bg-[color:var(--color-warn)]/10 rounded-full blur-3xl" />
      </div>

      <div className="relative w-full max-w-md text-center space-y-7">
        <div className="flex justify-center">
          <Brand size="lg" wordmarkClassName="text-ink" accentClassName="text-brand" />
        </div>

        <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-surface border border-line mx-auto">
          <Monitor size={28} className="text-brand" aria-hidden="true" />
        </div>

        <div className="space-y-3">
          <h1 className="text-2xl font-bold tracking-tight text-ink">
            Für Desktop optimiert
          </h1>
          <p className="text-sm text-ink-2 leading-relaxed">
            Der 1D-Toleranzrechner braucht Platz: parametrische Maßketten,
            Live-Tabellen und Ergebnisspalten passen nicht sinnvoll auf einen
            Telefon-Bildschirm. Öffne <strong className="text-ink">toleranz.app</strong> auf
            deinem Rechner oder Tablet im Querformat.
          </p>
        </div>

        <div className="flex flex-col gap-2">
          <a
            href="https://toleranzrechnung.de"
            className="inline-flex items-center justify-center gap-2 py-3 bg-brand hover:bg-brand text-ink rounded-2xl text-sm font-semibold transition-colors"
          >
            Mehr erfahren <ArrowRight size={14} aria-hidden="true" />
          </a>
          <Link
            to="/settings"
            className="inline-flex items-center justify-center gap-2 py-3 bg-surface hover:bg-surface-2 border border-line text-ink-2 rounded-2xl text-sm font-medium transition-colors"
          >
            <SettingsIcon size={14} aria-hidden="true" />
            Konto verwalten
          </Link>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[10px] font-bold text-ink-3 uppercase tracking-widest">
          <Link to="/legal/imprint" className="hover:text-ink-2 transition-colors">Impressum</Link>
          <Link to="/legal/privacy" className="hover:text-ink-2 transition-colors">Datenschutz</Link>
          <Link to="/legal/terms" className="hover:text-ink-2 transition-colors">AGB</Link>
        </div>
      </div>
    </div>
  );
}
